exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".uu5-bricks-label {\n  display: inline-block;\n}\n.uu5-bricks-label > .uu5-common-disabled-cover {\n  border-radius: inherit;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./bricks/label.less
// module id = 223
// module chunks = 0